export default __webpack_public_path__ + "static/media/Tanmay Srivastava_Outreach Team Lead.a468a5c6.jpg";